// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"ccfda6eb9f--wrapper--zVDgf"};